import Table from "../util/table/Table.jsx";
import Counter from "../util/Counter.jsx";
import {DECIMAL_FORMAT} from "../../util/numbers.js";

export default ({assets}) => {
    return (
        <>
            <Table className='total-assets'>
                <tbody>
                {Object.entries(assets).map(asset => {
                    const [code, props] = asset
                    return <Row key={code} code={code} {...props} />
                })}
                </tbody>
            </Table>
        </>
    )
}

const Row = ({code, name, quantity, totalValue, addresses}) => {
    return (
        <tr>
            <td className=''>
                <div className='hide-portrait'>
                    {name}
                </div>
            </td>
            <td>
                <Counter
                    amount={quantity}
                    decimals={DECIMAL_FORMAT.FLEX_DEC}
                    suffix={code}
                />
            </td>
            <td className='numeric hide-portrait'>
                <Counter
                    amount={addresses}
                    decimals={DECIMAL_FORMAT.FLEX_INT}
                    suffix={'addresses'}
                />
            </td>
            <td className='numeric'>
                <Counter
                    amount={totalValue}
                    decimals={0}
                    suffix='kr'
                />
            </td>
        </tr>
    )
}